module.exports = __webpack_public_path__ + "static/media/striped_bar_prewash_tall.8ba6c619.svg";